import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const ORDERS = gql`
  query Orders($filter: OrderFilter, $sort: OrderSort) {
    orders(filter: $filter, sort: $sort) {
      count
      data {
        orderNumber
        id
        deliveryType
        orderItemCount
        deliveryPartner {
          firstName
          lastName
          id
          userNumber
        }
        library {
          id
        }
        user {
          firstName
          lastName
          id
          userNumber
          pincode {
            pincode
          }
        }
        createdAt
        expectedDeliveryTime
        status
        cancellationData {
          additionalComment
          reason
        }
      }
    }
  }
`;

export const ORDER_ITEMS = gql`
  query OrderItems($where: OrderUniqueInput) {
    orderItems(where: $where) {
      count
      data {
        isPreOrder
        stockAtBooking
        libraryInventory {
          availableStock
          physicallyAvailableStock
          pendingDispatchCount
        }
        id
        transferOrders {
          status
        }
        toy {
          id
          toyNumber
          name
          category {
            name
          }
          ageGroup {
            minAge
            maxAge
          }
        }
        status
      }
    }
  }
`;

export const PINCODES = gql`
  query Pincodes($filter: PincodesFilter, $sort: PincodesSort) {
    pincodes(filter: $filter, sort: $sort) {
      count
      data {
        pincode
        id
      }
    }
  }
`;

export const LIBRARY_USERS = gql`
  query libraryUsers($filter: UsersFilter, $sort: UsersSort) {
    libraryUsers(filter: $filter, sort: $sort) {
      count
      data {
        userNumber
        firstName
        lastName
        id
      }
    }
  }
`;

export const NEW_RETURN_ORDER_COUNT = gql`
  query returnOrders(
    $filter: ReturnOrderItemFilter
    $sort: ReturnOrderSort
  ) {
    returnOrders(filter: $filter, sort: $sort) {
      count
      returnRequestedOrderCount
    }
  }
`;